import { render, staticRenderFns } from "./VersionesPTI.vue?vue&type=template&id=2752c733"
import script from "./VersionesPTI.vue?vue&type=script&lang=js"
export * from "./VersionesPTI.vue?vue&type=script&lang=js"
import style0 from "./VersionesPTI.vue?vue&type=style&index=0&id=2752c733&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports